/* eslint-disable no-mixed-spaces-and-tabs */
/* eslint-disable react/prop-types */
/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-nocheck

import React, { useState, useEffect } from 'react'
import ApolloClient, { gql } from 'apollo-boost'
import { Modal, Select } from 'antd'

const { Option } = Select

const ChooseFromTemplate = ({ addNewQuestion }) => {
	const [showModal, setShowModal] = useState(true)
	const [questions, setQuestions] = useState([])
	const [selectedQuestion, setSelectedQuestion] = useState(null)

	const Client = new ApolloClient({
		uri: process.env.REACT_APP_GRAPHQL_ENDPOINT,
		headers: {
			'X-Hasura-Admin-Secret': process.env.REACT_APP_HASURA_SECRET
		}
	})

	// Get all questions
	const getQuestions = () => {
		const questionQuery = gql`query {
      Question(where: {isTemplate: {_eq: true}}) {
        Answers(order_by: {sequence: asc}) {
          id
          answer
          answerChinese
          answerMalay
          sequence
        }
        id
        questionChinese
        questionMalay
        question
        questionType
        isTemplate
        maxAnswer
      }
    }`

		Client.query({
			query: questionQuery,
		}).then((questions) => {
			const { data: { Question } } = questions
			if (Question.length > 0) setQuestions(Question)
		})
	}

	const handleOk = () => {
		setShowModal(false)
		addNewQuestion(questions[selectedQuestion])
	}

	const handleCancel = () => {
		setShowModal(false)
	}

	useEffect(() => {
		if (questions.length <= 0) {
			getQuestions()
		}
		// eslint-disable-next-line
  }, [questions])

	return (
		<>
			<Modal
				title='Search for template question'
				visible={showModal}
				okText='Add Question'
				onOk={handleOk}
				onCancel={handleCancel}
				okButtonProps={{ disabled: selectedQuestion === null }}
			>
				<Select
					showSearch
					placeholder='Enter to search for job question template'
					style={{ width: '100%' }}
					onChange={(val) => {
						setSelectedQuestion(val)
					}}
					allowClear
					filterOption={(input, option) =>
						option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
				>
					{questions.map((question, i) => {
						return (<Option key={i} value={i}>{question.question}</Option>)
					})}
				</Select>
				{selectedQuestion !== null &&
          <div>
          	<br />
          	<h4>Question Details</h4>
          	<p style={{ fontSize: '14px' }}>
          		<span>{questions[selectedQuestion].question}</span><br />
          		<span>{questions[selectedQuestion].questionChinese}</span><br />
          		<span>{questions[selectedQuestion].questionMalay}</span>
          	</p>
          	<h4>Answers</h4>
          	{questions[selectedQuestion].Answers.map((qs, i) => {
          		return (
          			<div key={qs.id} style={{ fontSize: '14px' }}>
          				<strong>{i + 1}</strong><br />
          				<span>{qs.answer}</span><br />
          				{questions[selectedQuestion].questionType !== 'YESNO' && <><span>{qs.answerChinese}</span><br /></>}
          				{questions[selectedQuestion].questionType !== 'YESNO' && <><span>{qs.answerMalay}</span><br /></>}
          				<br />
          			</div>
          		)
          	})}
          </div>}
			</Modal>
		</>
	)
}

export default ChooseFromTemplate
